import { render, staticRenderFns } from "./Live.vue?vue&type=template&id=2003d15b&"
import script from "./Live.vue?vue&type=script&lang=js&"
export * from "./Live.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2003d15b')) {
      api.createRecord('2003d15b', component.options)
    } else {
      api.reload('2003d15b', component.options)
    }
    module.hot.accept("./Live.vue?vue&type=template&id=2003d15b&", function () {
      api.rerender('2003d15b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/asset/Live.vue"
export default component.exports